import React from 'react';

export const EnochFilterContext = React.createContext({
  email: '',
  ipAddress: null,
  fromDate: null,
  toDate: null,
});

export const useEnochFilterContext = () => React.useContext(EnochFilterContext);
